// LIST
export const GET_GOVERNANCE = "app/TOOLS/GET_GOVERNANCE";
export const GET_GOVERNANCE_SUCCESS = "app/TOOLS/GET_GOVERNANCE_SUCCESS";
export const GET_GOVERNANCE_FAILURE = "app/TOOLS/GET_GOVERNANCE_FAILURE";

export const SAVE_GOVERNANCE = "app/TOOLS/SAVE_GOVERNANCE";
export const SAVE_GOVERNANCE_SUCCESS = "app/TOOLS/SAVE_GOVERNANCE_SUCCESS";
export const SAVE_GOVERNANCE_FAILURE = "app/TOOLS/SAVE_GOVERNANCE_FAILURE";

export const LOAD_GOVERNANCE_VERSION = "app/TOOLS/LOAD_GOVERNANCE_VERSION";
export const LOAD_GOVERNANCE_VERSION_SUCCESS =
  "app/TOOLS/LOAD_GOVERNANCE_VERSION_SUCCESS";
export const LOAD_GOVERNANCE_VERSION_FAILURE =
  "app/TOOLS/LOAD_GOVERNANCE_VERSION_FAILURE";

export const GET_RESIDENT_GOVERNANCE = "app/TOOLS/GET_RESIDENT_GOVERNANCE";
export const GET_RESIDENT_GOVERNANCE_SUCCESS =
  "app/TOOLS/GET_RESIDENT_GOVERNANCE_SUCCESS";
export const GET_RESIDENT_GOVERNANCE_FAILURE =
  "app/TOOLS/GET_RESIDENT_GOVERNANCE_FAILURE";

export const UPDATE_GOVERNANCE_STATUS = "app/TOOLS/UPDATE_GOVERNANCE_STATUS";
export const UPDATE_GOVERNANCE_STATUS_SUCCESS =
  "app/TOOLS/UPDATE_GOVERNANCE_STATUS_SUCCESS";
export const UPDATE_GOVERNANCE_STATUS_FAILURE =
  "app/TOOLS/UPDATE_GOVERNANCE_STATUS_FAILURE";

export const COMPLETE_GOVERNANCE_ITEM = "app/TOOLS/COMPLETE_GOVERNANCE_ITEM";
export const COMPLETE_GOVERNANCE_ITEM_SUCCESS =
  "app/TOOLS/COMPLETE_GOVERNANCE_ITEM_SUCCESS";
export const COMPLETE_GOVERNANCE_ITEM_FAILURE =
  "app/TOOLS/COMPLETE_GOVERNANCE_ITEM_FAILURE";

// Dismiss (with reason / optional set-as-baseline) — POST .../dismiss
export const DISMISS_GOVERNANCE_ITEM = "app/TOOLS/DISMISS_GOVERNANCE_ITEM";
export const DISMISS_GOVERNANCE_ITEM_SUCCESS =
  "app/TOOLS/DISMISS_GOVERNANCE_ITEM_SUCCESS";
export const DISMISS_GOVERNANCE_ITEM_FAILURE =
  "app/TOOLS/DISMISS_GOVERNANCE_ITEM_FAILURE";

// Mute this resident's alerts of this kind (24h / 48h / 7d / until turned back on).
export const MUTE_GOVERNANCE_ITEM = "app/TOOLS/MUTE_GOVERNANCE_ITEM";

// "Check later" — snooze until a date (auto-reopens via cron) — POST .../snooze
export const SNOOZE_GOVERNANCE_ITEM = "app/TOOLS/SNOOZE_GOVERNANCE_ITEM";
export const SNOOZE_GOVERNANCE_ITEM_SUCCESS =
  "app/TOOLS/SNOOZE_GOVERNANCE_ITEM_SUCCESS";
export const SNOOZE_GOVERNANCE_ITEM_FAILURE =
  "app/TOOLS/SNOOZE_GOVERNANCE_ITEM_FAILURE";
